import React, {useContext, useEffect, useState,useRef, useCallback} from 'react';
import {Container} from "react-bootstrap";
import {AgGridReact} from "ag-grid-react";
import ActionsRenderer from "components/ActionsRenderer";
import AgGridToolbar from "components/AgGridToolbar/AgGridToolbar";
import WiresParamsBadge from "./WiresParamsBadge";
import PageHeader from "components/PageHeader";
import useWindowDimensions from "hooks/Dimensions";
import {WiresPanelContext} from "./context";
import {ActionPanelContext} from "context/action";
import {SecurityContext} from "context/security";
import AuthenticationService from "service/AuthenticationService";
import {EntityAccountsContext} from "components/entity-accounts/context";
import {
    dateToString,
    stringToDate
} from "utils/FormatUtils";
import {UtilsContext} from "context/utils";
import {ToastContext} from "context/Toast";
import {WIRE_PANEL_VIEW_WIRE_PAGE} from "./context/WiresPanelContext";
import {
    ENABLE_SCROLL_BUTTONS_PAGINATION_SIZE,
    GRID_COLUMN_PROPERTY
} from "utils/Constants";
import {createExcelExportParams, getFilteredColumns} from "../../utils/ExcelExportUtils";
import ActionsApproveRejectRenderer from "../../components/ActionsApproveRejectRenderer";
import ActionApproveRejectPanelLayout from "../../layouts/ActionApproveRejectPanelLayout";
import {
    WIRES_APPROVE_REJECT_VALIDATE_AND_APPROVE_REJECT,
    WIRES_LIST,
    WIRES_WIRE_SEARCH,
    WIRES_WIRES_LIST_SAVE
} from "service/UrlConstant";
import Service from "../../service/Service";
import {cellAlignment, numberFormatter} from "../../utils/NumberUtils";
import {
    addPropertiesToGridColumns,
    getDisplayedNumberOfGridRows,
    updateGridColumDefs
} from "../../utils/gridColumnUtils";
import ApproveRejectRenderer from "./ApproveRejectRenderer";
import ScrollButton from "../../components/AgGridToolbar/ToolBarButtons/ScrollButton";
export default function WiresResultPanel(props) {
    const gridRef = useRef();
    const [rowData, setRowData] = useState([]);
    const [gridApi, setGridApi] = useState(null);
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [columnDefs, setColumnDefs] = useState([]);
    const {isDesktop,isMobile} = useWindowDimensions();
    const [show, setShow] = useState(false);
    const [approveEnabledOnWire, setApproveEnabledOnWire] = useState(false)
    const [rejectEnabledOnWire, setRejectEnabledOnWire] = useState(false)
    const [modalTitle, setModalTitle] = useState('');
    const [showApprove, setShowApprove] = useState(false);
    const [showReject, setShowReject] = useState(false);
    const {wireResultsDisplayState,setWireResultsDisplayState,clearWirePanelDisplayState,
        wirePanelPageState,setHandleApproveFunction,setHandleRejectFunction,wirePanelFilterState, showGridToolbar} = useContext(WiresPanelContext)
    const {setHandleSaveFunction,setHandleDeleteFunction, setHandleRenameFunction, setHandleExportFunction,setSavedSearchName} = useContext(ActionPanelContext)
    const {
        makeDeleteRequest,
        makePatchRequestWithParams,
        makePostRequest
    } = useContext(SecurityContext);
    const {entityAccountsNoSwap,clearEntityAccounts} = useContext(EntityAccountsContext);
    const {hiddenExportGridApi,paginationPageSize, setPaginationPageSize, showButton, setShowButton} = useContext(UtilsContext);
    const {success, error,alert} = useContext(ToastContext);

    const lookupActionApproveReject = (key) => {
        let isApproveEnabled = key.isApproveEnabled?key.isApproveEnabled===1:false
        let isRejectEnabled = key.isRejectEnabled?key.isRejectEnabled===1:false

        return isApproveEnabled || isRejectEnabled
    };
    const lookupActionApprove = (key) => {
        return key.isApproveEnabled ? key.isApproveEnabled === 1 : false
    };
    const lookupActionReject = (key) => {
        return key.isRejectEnabled ? key.isRejectEnabled === 1 : false
    };
    const columnTypes ={
        actionColType: {
            sortable: false,
            resizable: false,
            floatingFilter: false,
            filter: false,
            enableCellChangeFlash: false,
            pinned:isDesktop?'':'right',
            width:isDesktop?250:100,
        },
        flexColType: {
            sortable: false,
            resizable: false,
            floatingFilter: false,
            filter: false,
            enableCellChangeFlash: false,
            suppressMenu:true,
            flex:1,
            suppressMovable:true,
        }
    }

    const defaultColDef = {
        sortable:true,
        resizable:true,
        floatingFilter:true,
        filter:true,
        enableCellChangeFlash:true,
        lockPinned:!!isMobile,
    };

    const statusCellRules = {
        'red-cell': params => params.value === 'Rejected',
        'green-cell': params => params.value === 'Completed',
        'orange-cell': params => params.value === 'Pending',
    };

    const LogItem = function (params){
        return(<>
            {
                params.value.toString().split("\r\n").map( (log, index) => {
                    return (<React.Fragment key={`log-line-${index}`}>{log}<br /></React.Fragment>)
                })}
        </>);
    }

    const logRenderer = function (props){
        if(!props.data.comments)
            return (<></>)
        return <LogItem value = {props.data.comments}/>
    }
    const logRendererCustodianMessage = function (props){
        if(!props.data.custodianMessage)
            return (<></>)
        return <LogItem value = {props.data.custodianMessage}/>
    }
    const instructionsRenderer = function (props){
        if(!props.data.wireInstructions)
            return (<></>)
        return <LogItem value ={props.data.wireInstructions}/>
    }

    const wireApproveOrRejectValidAndAction = (action,gridApi) => {

        const selectedRow = gridApi.getSelectedRows()[0];

        const data = {
            indStatus: action,
            id: selectedRow.id,
            idWireNum: selectedRow.idWireNum,
        };

        const onSuccessResponse = (response) => {
            let statusResponseModel = response.data
            if (statusResponseModel) {
                if (statusResponseModel.status === 'Success'){
                    // approve or reject success
                    if (action) {
                        if (action === 'REJECT'){
                            setShowReject(false)
                            success("Wire Rejected Successfully !!")
                        }
                        else if (action === 'APPROVE'){
                            setShowApprove(false)
                            success("Wire Approved Successfully !!")
                        }
                    }
                    reloadWireData(gridApi,selectedRow);
                    setShow(false);
                } else {
                    error(statusResponseModel.message)
                }
            }
        }

        const onErrorResponse = (err) => {
            console.error(err);
            error(`Error occurred: ${err.response.data}`)
        }

        makePostRequest(data, WIRES_APPROVE_REJECT_VALIDATE_AND_APPROVE_REJECT,
            onSuccessResponse, onErrorResponse);

    }

    const refreshGridAfterApprove = ( gridApi, onSuccess, onError) => {
        wireApproveOrRejectValidAndAction('APPROVE' ,gridApi);

    };

    const refreshGridAfterReject = (gridApi,onSuccess,onerror) => {
       wireApproveOrRejectValidAndAction('REJECT' ,gridApi);
    }

    const reloadWireData = (gridApi,selectedRow) =>{
        const status = ( (wirePanelFilterState.status ==="")?"ALL":wirePanelFilterState.status);
        const params = {
            idManager: entityAccountsNoSwap.managerId,
            idAccount: entityAccountsNoSwap.accountId,
            startDate:dateToString(wirePanelFilterState.startDate),
            endDate:dateToString(wirePanelFilterState.endDate),
            status:status,
        }

        const onSuccess = (res) => {
            const wireResultsDisplay = JSON.parse(JSON.stringify(wireResultsDisplayState));
            wireResultsDisplay.resData = ([...res.data]);
            setWireResultsDisplayState(wireResultsDisplay);
            setRowData(wireResultsDisplay.resData);
        }

        const onError = (err) => {
            console.error('Error when retrieving wires - ', err);
            error("There was an error when loading wires !!");
        }
        makePostRequest(params, WIRES_WIRE_SEARCH, onSuccess, onError);
    }

    const wireAppRejectDataValueGetter = function (params) {
        let appRejData = {
            cdUser: AuthenticationService.getAuthenticatedUserName(),
            wireId:params.data.id,
            status:params.data.indStatus,
            comments: params.data.comments,
            mnyOut:params.data.mnyOut,
            ccyOut:params.data.ccyOut,
            cdClient:params.data.cdClient,
            pendingCltApprovals: params.data.pendingCltApprovals,
            isApproveEnabled: params.data.isApproveEnabled,
            isRejectEnabled: params.data.isRejectEnabled,
            managerName:wireResultsDisplayState.wireSearch.managerName
        }
        return appRejData;
    }

    const handleActionIconClick = (field) => {
        setShow(true);
        setApproveEnabledOnWire(!!(field.isApproveEnabled && field.isApproveEnabled === 1))
        setRejectEnabledOnWire(!!(field.isRejectEnabled && field.isRejectEnabled === 1))
        setModalTitle(field.cdClient);
    }

    const handleApproveActionClicked = (field)=>{
        setShow(true);
        setShowApprove(true);
        setModalTitle(field.cdClient);
    }

    const handleRejectActionClicked = (field)=>{
        setShow(true);
        setShowReject(true);
        setModalTitle(field.cdClient);
    }

    const setupActionColumns = () => {
        let updatedColumnDefs = [...columnDefsResultsPanel];
        updatedColumnDefs.splice(0, 0, {
            headerName: 'Actions',
            field: 'action', colId: 'action', width: 135,
            type: 'actionColType',
            cellRenderer: "approveRejectRenderer",
            valueGetter: wireAppRejectDataValueGetter,
            cellRendererParams: {
                clicked: (data) => handleActionIconClick(data),
                onApproveActionClicked: (appRejData) => handleApproveActionClicked(appRejData),
                onRejectActionClicked: (appRejData) => handleRejectActionClicked(appRejData),
                showApproveRejectFun: (appRejData) => lookupActionApproveReject(appRejData),
                showApproveFun: (appRejData) => lookupActionApprove(appRejData),
                showRejectFun: (appRejData) => lookupActionReject(appRejData),
            }
        });
        return updatedColumnDefs;
    }

    useEffect(() => {
        setupActionColumns();
        if (WIRE_PANEL_VIEW_WIRE_PAGE === wirePanelPageState.currentPage) {
            const rowDataNew = wireResultsDisplayState.resData;
            rowDataNew.map(e => (e["managerName"] = wireResultsDisplayState.wireSearch.managerName));
            const updatedColDefsResultsPanel = addPropertiesToGridColumns(setupActionColumns(), GRID_COLUMN_PROPERTY)
            setColumnDefs( updatedColDefsResultsPanel);
            setRowData(rowDataNew);
            setHandleSaveFunction({handleSave: saveWireList, gridApi:null});
            setHandleRenameFunction({handleRename: updateSavedWire, gridApi:  null});
            setHandleDeleteFunction({handleDelete: deleteSavedWire, gridApi:  null});
            setHandleExportFunction({handleExport:exportQueryList, gridApi: gridApi});
        }

    },[wirePanelPageState])

    const saveWireList = (name, gridApi, onSuccess, onError) => {
        const params = {
            name: name,
            idAccount: wireResultsDisplayState.wireSearch.accountId ? wireResultsDisplayState.wireSearch.accountId : 0,
            idManager:wireResultsDisplayState.wireSearch.managerId,
            status:wireResultsDisplayState.wireSearch.status,
            cdClient:wireResultsDisplayState.wireSearch.clientCode,
            startDate: (wireResultsDisplayState.wireSearch.startDate ? dateToString(wireResultsDisplayState.wireSearch.startDate) : ''),
            endDate: (wireResultsDisplayState.wireSearch.endDate ? dateToString(wireResultsDisplayState.wireSearch.endDate) : '')
        };

        const onSuccessResponse = (res) => {
            if(onSuccess) onSuccess();
            if(res.data.wireListId){
                wireResultsDisplayState.isSavedWire = true;
                wireResultsDisplayState.savedName = res.data.name;
                wireResultsDisplayState.savedWireListId = res.data.wireListId;
                setSavedSearchName(name);
                setWireResultsDisplayState(wireResultsDisplayState);

            }
            success("Successfully created wire search");
        }

        const onErrorResponse = (err) => {
            console.error(err);
            if(onError) onError(err);
        }
        makePostRequest(params, WIRES_LIST, onSuccessResponse, onErrorResponse);
    }

    const updateSavedWire = (name, gridApi, onSuccess, onError) => {
        const params = {
            "savedNameUpdated":name,
        }
        const onSuccessResponse = (response) => {
            if(onSuccess) onSuccess();
            wireResultsDisplayState.savedName = name;
            setWireResultsDisplayState(wireResultsDisplayState);
            setSavedSearchName(name);
            success('Wire name saved successfully.');
        }

        const onErrorResponse = (err) => {
            const msg = "Error occurred when updating the Saved Wire name";
            console.error(msg + ": ", err);
            if(onError) onError(err);
        }

        makePatchRequestWithParams(
            WIRES_WIRES_LIST_SAVE + "/" + wireResultsDisplayState.savedWireListId , params, onSuccessResponse, onErrorResponse);
    };

    const deleteSavedWire = (gridApi, onSuccess, onError) => {
        const onSuccessResponse = (response) => {

            if(onSuccess) onSuccess();
            clearEntityAccounts(undefined,undefined,true);
            clearWirePanelDisplayState();
            success('Wire list deleted successfully.');
        }

        const onErrorResponse = (err) => {
            const msg = "Error when updating the saved Wire name";
            console.error(msg + ": ", err);
            if(onError) onError(err);
            error(msg);
        }

        makeDeleteRequest(
            WIRES_WIRES_LIST_SAVE + "/" + wireResultsDisplayState.savedWireListId, onSuccessResponse, onErrorResponse);
    };

    const exportQueryList = (type, rowData, gridApi) => {
        //Set Column definition
        hiddenExportGridApi.current.api.setColumnDefs(columnDefsResultsPanel);
        //Set Data
        hiddenExportGridApi.current.api.setRowData(rowData || wireResultsDisplayState.resData);
        let filteredColumnNames = getFilteredColumns(gridRef);
        //Export as csv/excel
        type==='EXCEL' ?
            hiddenExportGridApi.current.api.exportDataAsExcel(createExcelExportParams('Wires', filteredColumnNames)) :
                hiddenExportGridApi.current.api.exportDataAsCsv({columnKeys: filteredColumnNames})
    }

    const onGridReady = (params) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    }

    // Re-register approve/reject handlers whenever the grid api or the
    // search criteria change so the captured closures (used by reloadWireData)
    // always read the latest filter state instead of a stale value.
    useEffect(() => {
        if (gridApi) {
            setHandleApproveFunction({handleApprove: refreshGridAfterApprove, gridApi});
            setHandleRejectFunction({handleReject: refreshGridAfterReject, gridApi});
        }
    }, [gridApi, wirePanelFilterState, wireResultsDisplayState]);

    function pageTitle(){
        return "Wires "
    }

    const cellClicked=(params)=> {
        params.node.setSelected(true)
        params.api.ensureIndexVisible(params.node.rowIndex,'top');
    }

    const onDisplayedColumnsChanged = ()=> {
        if(gridColumnApi){
            const updatedColumnDefs = updateGridColumDefs(gridColumnApi, columnDefs)
            setColumnDefs(updatedColumnDefs)
        }
    }

    const onDataRendered = (params) => {
        setGridApi(params.api);
        params.columnApi.autoSizeAllColumns();
        setShowButton(getDisplayedNumberOfGridRows(gridApi) >= ENABLE_SCROLL_BUTTONS_PAGINATION_SIZE);
    }
    const onPaginationChange = (params) => {
        setShowButton(getDisplayedNumberOfGridRows(gridApi) >= ENABLE_SCROLL_BUTTONS_PAGINATION_SIZE);
    }
    return(<>
        <Container fluid>
            <PageHeader text={pageTitle()}>
                <WiresParamsBadge/>
            </PageHeader>

            { showGridToolbar && <AgGridToolbar title={wireResultsDisplayState.savedName}
                           wireScreen={true}
                           gridApi={gridApi}
                           gridColumnApi={gridColumnApi}
                           columnDefs={columnDefs}
                           setColumnDefs={setColumnDefs}
                           isSaved={wireResultsDisplayState.isSavedWire}
                                                paginationPageSize={paginationPageSize}
                                                setPaginationPageSize={setPaginationPageSize}
                                                showButton={showButton} setShowButton={setShowButton}>
            </AgGridToolbar>}
            <div className="ag-theme-alpine ag-grid-block">
                <AgGridReact
                    ref={gridRef}
                    cellClassRules={statusCellRules}
                    domLayout={'autoHeight'}
                    pagination={true}
                    frameworkComponents={{
                        actionsRenderer: ActionsRenderer,
                        logRenderer: logRenderer,
                        logRendererCustodianMessage: logRendererCustodianMessage,
                        approveRejectRenderer: ActionsApproveRejectRenderer,
                        instructionsRenderer: instructionsRenderer
                    }}
                    paginationPageSize={paginationPageSize}
                    groupDefaultExpanded={'1'}
                    enableRowGroup={false}
                    suppressDragLeaveHidesColumns={true}
                    suppressMakeColumnVisibleAfterUnGroup={true}
                    suppressModelUpdateAfterUpdateTransaction={true}
                    suppressScrollOnNewData={true}
                    suppressAggFuncInHeader={true}
                    allowShowChangeAfterFilter={false}
                    rowGroupPanelShow={'never'}
                    enableSorting={true}
                    enableFilter={true}
                    onGridReady={onGridReady}
                    onRowDataChanged={onDataRendered}
                    defaultColDef={defaultColDef}
                    columnDefs={columnDefs}
                    columnTypes={columnTypes}
                    rowData={rowData}
                    animateRows={true}
                    onCellClicked={cellClicked}
                    onPaginationChanged={onPaginationChange}
                >
                </AgGridReact>
            </div>
        </Container>
        {showButton && <ScrollButton showButton={showButton}/>}
        <ActionApproveRejectPanelLayout show={show} setShow={setShow} showApprove={showApprove} setShowApprove={setShowApprove} showReject={showReject} setShowReject={setShowReject}  gridApi={gridApi} 
           modalTitle={modalTitle} approveEnabledOnWire={approveEnabledOnWire} rejectEnabledOnWire={rejectEnabledOnWire}/>
    </>);
}

export const columnDefsResultsPanel = [
    {headerName: 'id', field: 'id',hide:true, colId: 'id', suppressColumnsToolPanel:true},
    {headerName: 'idWireNum', field: 'idWireNum',hide:true, colId: 'idWireNum', suppressColumnsToolPanel:true},
    {headerName: 'idManager', field: 'idManager',hide:true, suppressColumnsToolPanel:true},
    {headerName: 'idAccount', field: 'idAccount',hide:true, suppressColumnsToolPanel:true},
    {headerName: 'Date', field: 'dtEffective', valueGetter: (params)=>stringToDate(dateToString(params.data.dtEffective)),width:130},
    {headerName: 'Status', field: 'indStatus',width:120},
    {headerName: 'Account', field: 'cdClient',width:135},
    {headerName: '3rd Party', field: 'thirdParty',width:120},
    {headerName: 'Outgoing Funds', field: 'mnyOut',cellStyle: cellAlignment,valueFormatter: numberFormatter},
    {headerName: 'Out CCY', field: 'ccyOut',width:100},
    {headerName: 'Reason', field: 'reason'},
    {headerName: 'Wire Instructions', field: 'wireInstructions',wrapText :true,autoHeight:true,resizable:true,cellRenderer: 'instructionsRenderer'},
    {headerName: 'Comments', field: 'comments',wrapText :true,autoHeight:true,resizable:true,cellRenderer: 'logRenderer'},
    {headerName: 'Custodian Message', field: 'custodianMessage',wrapText :true,autoHeight:true,resizable:true, cellRenderer: 'logRendererCustodianMessage'},
    {headerName: 'userCode', field: 'createdBy',hide:true,suppressColumnsToolPanel:true},
    {headerName: '', field: '', type: 'flexColType', suppressColumnsToolPanel: true},
];

// const updatedColDefsResultsPanel = addPropertiesToGridColumns(columnDefsResultsPanel, GRID_COLUMN_PROPERTY)